import { Grid, Box, Typography, Card, Avatar, Rating } from "@mui/material";
import { Container } from "@mui/system";
import React from "react";
import {
  antivirus1,
  duns1,
  iso1,
  iso2,
  lockicon,
  ssl1,
  vapt1,
} from "../iconsImports";

const testimonials = [
  {
    text: "DilliPay made payments easy! The experience is smooth and efficient.",
    name: "Arpita",
    location: "Delhi, India",
    image: "/images/arpita.jpg",
    rating: 5,
  },
  {
    text: "Bulk payments are hassle-free! The team is very supportive and helpful.",
    name: "Sid",
    location: "Mumbai, India",
    image: "/images/sid.jpg",
    rating: 4,
  },
  {
    text: "DilliPay transformed how we handle transactions. Highly recommend it!",
    name: "Neha",
    location: "Bangalore, India",
    image: "/images/neha.jpg",
    rating: 5,
  },
  {
    text: "Seamless payment system, integrates perfectly with our workflow.",
    name: "Rahul",
    location: "Chennai, India",
    image: "/images/rahul.jpg",
    rating: 4.8,
  },
  {
    text: "The fastest and most reliable payment solution we've used.",
    name: "Priya",
    location: "Mumbai, India",
    image: "/images/priya.jpg",
    rating: 5.0,
  },
  {
    text: "User-friendly interface with excellent customer support.",
    name: "Amit",
    location: "Delhi, India",
    image: "/images/amit.jpg",
    rating: 4,
  },
  {
    text: "A game-changer for our business transactions!",
    name: "Sneha",
    location: "Bangalore, India",
    image: "/images/sneha.jpg",
    rating: 5,
  },
  {
    text: "Secure and hassle-free payments every time.",
    name: "Vikram",
    location: "Pune, India",
    image: "/images/vikram.jpg",
    rating: 4.6,
  },
];

const LandingPageTestimonials = () => {
  return (
    <Grid container sx={{ backgroundColor: "#f9fafc", py: 5 }}>
      <Container maxWidth="xl">
        <Grid item xs={12}>
          <Box
            sx={{
              py: 6,
              overflow: "hidden",
              background: "linear-gradient(135deg, #f8fafc 0%, #eef2ff 100%)",
              borderRadius: "24px",
            }}
          >
            {/* Heading */}
            <Typography
              variant="h4"
              sx={{
                textAlign: "center",
                fontWeight: 700,
                mb: 4,
                color: "#111827",
              }}
            >
              Trusted & Certified
            </Typography>

            {/* Slider */}
            <Box
              sx={{
                display: "flex",
                width: "max-content",
                animation: "scroll 25s linear infinite",

                "@keyframes scroll": {
                  from: {
                    transform: "translateX(0)",
                  },
                  to: {
                    transform: "translateX(-50%)",
                  },
                },
              }}
            >
              {[...Array(2)]
                .flatMap(() => [
                  ssl1,
                  iso1,
                  iso2,
                  antivirus1,
                  duns1,
                  lockicon,
                  vapt1,
                ])
                .map((icon, index) => (
                  <Box
                    key={index}
                    sx={{
                      width: 180,
                      height: 120,
                      mx: 2,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      background: "rgba(255,255,255,0.8)",
                      backdropFilter: "blur(10px)",
                      borderRadius: "20px",
                      border: "1px solid rgba(255,255,255,0.3)",
                      boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                      transition: "0.3s",
                      "&:hover": {
                        transform: "translateY(-8px)",
                      },
                    }}
                  >
                    <img
                      src={icon}
                      alt=""
                      style={{
                        maxHeight: "70px",
                        maxWidth: "120px",
                        objectFit: "contain",
                      }}
                    />
                  </Box>
                ))}
            </Box>
          </Box>
        </Grid>

        {/* Section Title */}
        <Typography
          variant="h4"
          align="center"
          sx={{
            fontFamily: "'Poppins', sans-serif",
            fontWeight: 700,
            textTransform: "uppercase",
            color: "#333",
            letterSpacing: "1px",
            mb: 3,
            fontSize: { xs: "1.5rem", md: "2rem" }, // Responsive font size
          }}
        >
          What Our Customers Say
        </Typography>

        <Typography
          variant="body1"
          align="center"
          sx={{
            mb: 4,
            color: "#666",
            fontFamily: "'Poppins', sans-serif",
            fontSize: { xs: "0.9rem", md: "1.1rem" }, // Adjusted for readability
          }}
        >
          Hear success stories from users who trust DilliPay for seamless
          payments.
        </Typography>

        {/* Scrolling Testimonials */}
        <Box
          sx={{
            overflow: "hidden",
            whiteSpace: "nowrap",
            position: "relative",
          }}
        >
          <Box
            sx={{
              display: "flex",
              animation: "scroll 30s linear infinite",
              "@keyframes scroll": {
                from: { transform: "translateX(0)" },
                to: { transform: "translateX(-100%)" },
              },
              gap: 5, // Space between testimonial cards
            }}
          >
            {[...testimonials, ...testimonials].map((testimonial, index) => (
              <Card
                key={index}
                sx={{
                  boxShadow: 3,
                  padding: 2,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  borderRadius: 4,
                  textAlign: "center",
                  backgroundColor: "#fff8e1",
                  border: "1px solid #ffcc80",
                  transition: "transform 0.3s, box-shadow 0.3s",
                  minWidth: "260px",
                  maxWidth: "270px",
                  wordWrap: "break-word",
                  "&:hover": {
                    transform: "scale(1.02)",
                    boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.1)",
                  },
                }}
              >
                <Avatar
                  alt={testimonial.name}
                  src={testimonial.image}
                  sx={{
                    width: 60,
                    height: 60,
                    mb: 1.5,
                    border: "2px solid #ffcc80",
                  }}
                />
                <Typography
                  variant="body2"
                  sx={{
                    fontStyle: "italic",
                    mb: 1,
                    color: "#444",
                    fontSize: "0.9rem",
                    fontFamily: "'Poppins', sans-serif",
                    whiteSpace: "normal",
                    overflowWrap: "break-word",
                  }}
                >
                  "{testimonial.text}"
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: "bold",
                    color: "#222",
                    fontSize: "0.9rem",
                  }}
                >
                  {testimonial.name}
                </Typography>
                <Typography
                  variant="caption"
                  sx={{
                    color: "#666",
                    fontSize: "0.75rem",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                  }}
                >
                  {testimonial.location}
                </Typography>
                <Rating
                  name="testimonial-rating"
                  value={testimonial.rating}
                  readOnly
                  sx={{ mt: 1 }}
                />
              </Card>
            ))}
          </Box>
        </Box>
      </Container>
    </Grid>
  );
};

export default LandingPageTestimonials;
